<template>
  <News />
</template>

<script>
import News from '@/components/content/news/AllNews.vue'

export default {
  name: 'NewsPage',
  components: { News }
}
</script>

<style scoped>

</style>
